import { apiAxios } from "./apiConfig"; // adjust path if needed

export interface MessageUser {
  id: string;
  firstName: string;
  lastName: string;
}

export interface MessageItem {
  id: string;
  messageDetail: string;
  createdAt: string;
  creatorName: string;
  roleName: string;
  users: MessageUser[];
}

export interface MessageListData {
  adminCount: string;
  studyTeamCount: string;
  count: number;
  rows: MessageItem[];
}

export interface MessageListResponse {
  status: boolean;
  data: MessageListData;
}

export const fetchCmsMessages = async (
  role: "admin" | "study team",
  pageId: number,
  limit: number,
): Promise<MessageListResponse> => {
  const response = await apiAxios.get<MessageListResponse>(`/message/list`, {
    params: {
      pageId,
      limit,
      role,
    },
  });

  return response.data;
};

// ----------------------
// CREATE MESSAGE
// ----------------------

export interface CreateMessagePayload {
  message: string;
  users: {
    id: string;
    isActive: string;
  }[];
}

export interface CreateMessageResponse {
  status: boolean;
  data: string;
}

export const createCmsMessage = async (
  payload: CreateMessagePayload,
): Promise<CreateMessageResponse> => {
  const response = await apiAxios.post<CreateMessageResponse>(
    "/message/create",
    payload,
  );

  return response.data;
};

export interface MessageDetailItem {
  id: string;
  messageDetail: string;
  createdBy: string;
  createdAt: string;
  creator: {
    id: string;
    name: string;
  };
}

export interface MessageDetailData {
  count: number;
  rows: MessageDetailItem[];
}

export interface MessageDetailResponse {
  status: boolean;
  data: MessageDetailData;
}

export const fetchCmsMessageDetails = async (
  userId: string,
  pageId: number,
  limit: number,
): Promise<MessageDetailResponse> => {
  const response = await apiAxios.get<MessageDetailResponse>(
    `/message/${userId}`,
    {
      params: {
        pageId,
        limit,
      },
    },
  );

  return response.data;
};
